import uiRouter from 'angular-ui-router';
import textAngular from 'textangular'
/*var module = angular.module('TeachingPlanModule', [
    uiRouter,
    textAngular
]);*/

import createTp from './views/createTeachingPlan.html';
import viewTp from './views/viewTeachingPlan.html';
import tpController from './controllers/createTeachingPlanController';
import tpViewController from './controllers/viewTeachingPlanController';
//import './createTeachingPlan.scss';
import _ from "underscore"
var module = angular.module('app.TeachingPlanModule', [
        'ui.router'
        //import modules
    ]).component('newTeachingPlan', {
        template: createTp,
        controller: tpController,
        controllerAs: tpController
    })
    .controller('tpController', tpController)
    .component('viewTeachingPlan', {
        template: viewTp,
        controller: tpViewController,
        controllerAs: tpViewController
    })
    .controller('tpViewController', tpViewController);

module.constant('TPCONSTANT', {
    RESOURCES_LABEL: {
        pdf: "Softcopy (PDF)",
       // flash: "Interactive Anime",
        video: 'Video',
        weblinks: 'Web Links',
        refbooks: 'Reference Books',
        activityForm: 'Activity',
        khanAcademy: 'Khan Academy',
        utubeVideo: 'YouTube',
        googleDocs: "Google Docs",
    },
    RESOURCES_TITLE: {
        pdf: "Softcopy",
      //  flash: "Interactive Anime",
        video: "Video",
        weblinks: "Web Links",
        refbooks: "Reference Books",
        practice: "Practice Activity",
        assessment: "Assessment Activity",
        khanAcademy: "Khan Academy",
        utubeVideo: "YouTube",
        googleDocs: "Google Docs"
    },
    RESOURCES_IMG: {
        pdf: "../../../../src/img/auth/pdf.png",
      //  flash: "../../../../src/img/auth/interactive_anime.png",
        video: '../../../../src/img/auth/video.png',
        weblinks: '../../../../src/img/auth/web.png',
        refbooks: '../../../../src/img/auth/refbook.png',
        activityForm: '../../../../src/img/auth/activity.png',
        khanAcademy: '../../../../src/img/auth/khan_academy.png',
        utubeVideo: '../../../../src/img/auth/utube.png',
        googleDocs: "../../../../src/img/auth/google_docs.png",
    },
    STATUS_CREATED: "created",
    STATUS_DRAFT: "draft",
    STATUS_SENT_FOR_APPROVAL: "sent_for_approval",
    STATUS_APPROVED: "approved",
    STATUS_REJECTED: "rejected",
    STATUS_CONDUCTED: "conducted",
    API_CREATE_TP: "/v0/teachingPlan/addTeachingPlan/",
    API_GET_TP: "/v0/teachingPlan/getTeachingPlan/",
    API_GET_TP_ACTIVITIES_DETAILS: '/v0/teachingPlan/getTeachingPlanActivitiesDetails/',
    API_TP_APPROVERS: "/v0/teachingPlan/approver-list",
    API_SEND_FOR_APPROVAL:"/v0/teachingPlan/send-plan-approval",
    API_REJECT_TP:"/v0/teachingPlan/reject-tp",
    API_APPROVE_TP:"/v0/teachingPlan/approve-tp",
    API_UPDATE_TP:"/v0/teachingPlan/edit-plan",
    API_COMPLETE_TP:"/v0/teachingPlan/complete-status",
    API_SELECT_TP: "/v0/teachingPlan/addTeachingPlanFromArchive",
    API_GET_CURRENT_DATE: "/v0/server/now"
})

module.config(function($stateProvider, $locationProvider) {
    "ngInject";
});


// WEBPACK FOOTER //
// ./src/app/authoring-tool/teachingPlan/teachingPlanModule.js